import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {useLazyLoginAsSubClientQuery} from '../../../../../services/cellcast.v2'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {resetRedux} from '../../../../Redux/store'
import {UpdateLoggedUserInfo} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {toast} from 'react-toastify'

export function useLoginAsOwnerUser() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loginAsUser] = useLazyLoginAsSubClientQuery()

  const handleLoginAsUser = (id: string, useGlobalLoading: boolean) => {
    if (useGlobalLoading) dispatch(startLoadding())
    loginAsUser(id)
      .then((res) => {
        if (res.data) {
          dispatch(resetRedux())
          const resData = res.data
          // reconfigure local storage
          localStorage.setItem('permission', JSON.stringify(resData.data.userPermissions))
          localStorage.setItem('currentUser', JSON.stringify(resData))
          localStorage.setItem('role', resData.data.user.role)
          localStorage.setItem('token', resData.data.token)
          localStorage.setItem('isSubAccount', 'true')

          dispatch(UpdateLoggedUserInfo(resData.data))
          navigate('/auth')
        } else if ('error' in res) {
          console.error('error login as user:', res.error)
          toast.error(res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        if (useGlobalLoading) dispatch(stopLoading())
      })
  }

  return handleLoginAsUser
}
